import { render, staticRenderFns } from "./DiyButtonGroup.vue?vue&type=template&id=51ca66f2&scoped=true"
import script from "./DiyButtonGroup.vue?vue&type=script&lang=js"
export * from "./DiyButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./DiyButtonGroup.vue?vue&type=style&index=0&id=51ca66f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ca66f2",
  null
  
)

export default component.exports